module.exports = __webpack_public_path__ + "media/elevadizo/buqueIzquierdaCargadorDerecha-dd-ap-ff1c82f8.png";